<template>
  <div>
    <!-- faq search section -->
    <section id="faq-search-filter">
      <b-card
        no-body
        class="faq-search"
        :style="{backgroundImage:`url(${require('@/assets/images/banner/banner.png')})`}"
      >
        <b-card-body class="text-center">
          <h2 class="text-primary">
            Hadi birkaç soruyu cevaplayalım

          </h2>
          <b-card-text class="mb-2">
            veya ihtiyacınız olan yardımı hızlıca bulmak için bir kategori seçin
          </b-card-text>

          <!-- form -->
          <b-form class="faq-search-input">
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="searchbar"
                v-model="faqSearchQuery"
                placeholder="Yardım ara..."
              />
            </b-input-group>
          </b-form>
          <!-- form -->

          <b-button
            variant="primary"
            class="mt-2"
            @click="newAdd()"
             v-if="isDeveloper"
          >
            <feather-icon
              icon="PlusIcon"
              class="mr-50"
            />
            <span class="align-middle">Yeni Ekle</span>
          </b-button>
        </b-card-body>
      </b-card>
    </section>
    <!--/ faq search section -->

    <!-- frequently asked questions tabs pills -->
    <section id="faq-tabs">
      <b-tabs
        vertical
        content-class="col-12 col-md-8 col-lg-9"
        pills
        nav-wrapper-class="faq-navigation col-md-4 col-lg-3 col-12"
        nav-class="nav-left"
      >

        <!-- payment tab -->
        <b-tab
          v-for="(category, index) in faqData"
          :key="index"
          :active="!index"
        >

          <!-- title -->
          <template #title>
            <feather-icon
              :icon="category.icon"
              size="18"
              class="mr-1"
            />
            <span class="font-weight-bold">{{ category.title }}</span>
          </template>

          <helps-list :options="category" @edit-help="editHelp" @delete-help="deleteHelp" />
        </b-tab>
        <!--/ payment tab -->

        <!-- sitting lady image -->
        <template #tabs-end>
          <b-img
            fluid
            :src="require('@/assets/images/illustration/faq-illustrations.svg')"
            class="d-none d-md-block mt-3"
          />
        </template>
        <!--/ sitting lady image -->
      </b-tabs>
    </section>
    <!--/ frequently asked questions tabs pills -->

    <!-- contact us -->
    <section class="faq-contact">
      <b-row class="mt-5 pt-75 text-center">
        <b-col cols="12">
          <h2>Sorununuz devam ediyor mu?</h2>
          <b-card-text class="mb-3">
            Yardım bölümümüzde bir sorunuz yoksa, her zaman bizimle iletişime geçebilirsiniz. En kısa sürede size cevap vereceğiz!
          </b-card-text>
        </b-col>
        <b-col sm="12">
          <b-card
            class="shadow-none py-1 faq-contact-card"
          >
            <b-avatar
              size="42"
              rounded
              variant="light-primary"
              class="mb-2"
            >
              <feather-icon
                icon="MailIcon"
                size="18"
              />
            </b-avatar>
            <h4>destek@dijitall.net</h4>
            <span class="text-body">Daha hızlı cevap almanın en iyi yolu!</span>
          </b-card>
        </b-col>
      </b-row>
    </section>
    <help-modal
      :is-help-modal-active.sync="isHelpModalActive"
      :categoryOptions="categoryOptions"
      :editing-help="editHelpData"
      @link-updated="handleHelpUpdated"
      @close="isHelpModalActive = false"
      @update:is-help-modal-active="$emit('update:is-help-modal-active', $event)"
    />
    <!--/ contact us -->
  </div>
</template>

<script>
import {
  BCard, BCardBody, BButton, BForm, BInputGroup, BFormInput, BCardText, BInputGroupPrepend, BTabs, BTab, BImg, BRow, BCol, BAvatar,
} from 'bootstrap-vue'
import HelpsList from './HelpsList.vue'
import HelpModal from './HelpModal.vue'
export default {
  components: {
    BForm,
    BCard,
    BRow,
    BCol,
    BAvatar,
    BCardBody,
    BInputGroup,
    BFormInput,
    BCardText,
    BInputGroupPrepend,
    BTabs,
    BTab,
    BImg,
    BButton,
    HelpsList,
    HelpModal,
  },
  data() {
    return {
      faqSearchQuery: '',
      faqData: {},
      isHelpModalActive: false,
      categoryOptions: [],
      editHelpData:null
    }
  },
  watch: {
    faqSearchQuery: {
      immediate: true,
      handler() {
        this.fetchData()
      },
    },
  },
  methods: {
    deleteHelp(helpId) {
  this.$swal({
    title: 'Emin misiniz?',
    text: "Bu işlem geri alınamaz!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Evet, Sil!',
    cancelButtonText: 'İptal',
    customClass: {
      confirmButton: 'btn btn-danger',
      cancelButton: 'btn btn-outline-secondary ml-1',
    },
    buttonsStyling: false,
  }).then(result => {
    if (result.value) {
      // Kullanıcı onayladıysa silme işlemini yap
      this.$http.delete(`/manage/help/${helpId}`)
        .then(() => {
          // Help'i UI'dan sil
          this.removeHelpFromUI(helpId);

          // Başarı mesajı
          this.$swal({
            icon: 'success',
            title: 'Silindi!',
            text: 'Yardım kaydı başarıyla silindi.',
            customClass: {
              confirmButton: 'btn btn-success',
            },
            buttonsStyling: false,
          });
        })
        .catch(error => {
          console.error('Error deleting help:', error);
          
          // Hata mesajı
          this.$swal({
            icon: 'error',
            title: 'Hata!',
            text: 'Silme işlemi sırasında bir hata oluştu.',
            customClass: {
              confirmButton: 'btn btn-danger',
            },
            buttonsStyling: false,
          });
        });
    }
  });
    },

    removeHelpFromUI(helpId) {
      this.faqData.forEach(category => {
        if (category.helps && Array.isArray(category.helps)) {
          const helpIndex = category.helps.findIndex(help => help.id === helpId);
          if (helpIndex !== -1) {
            category.helps.splice(helpIndex, 1);
          }
        }
      });
    }, 
    newAdd() {
      this.isHelpModalActive = true;
      this.editHelpData = null;
    },
    editHelp(data) {
      this.isHelpModalActive = true;
      this.editHelpData = data;
    },
    handleHelpUpdated(updatedHelpResponse) {
      const updatedHelp = updatedHelpResponse.data;

      // Kategoriyi bul
      const category = this.faqData.find(cat => cat.id === updatedHelp.category_id);
      
      if (category) {
        // helps array'ini kontrol et, yoksa oluştur
        if (!category.helps) {
          this.$set(category, 'helps', []);
        }
        
        const helpIndex = category.helps.findIndex(help => help.id === updatedHelp.id);
        
        if (helpIndex !== -1) {
          // Güncelle
          this.$set(category.helps, helpIndex, {
            ...category.helps[helpIndex],
            ...updatedHelp
          });
        } else {
          // Ekle
          category.helps.push({
            title: updatedHelp.title,
            content: updatedHelp.content,
            id: updatedHelp.id,
            category_id: updatedHelp.category_id,
            category_title: category.title
          });
        }
      }
    },
    fetchData() {
      this.$http.get('/manage/help',{ 
        params: { 
          q: this.faqSearchQuery
        }
      }).then(res => { 
        this.faqData = res.data.data;
        this.categoryOptions = res.data.categories.map(item => ({
          value: item.id,
          label: item.title,
        }));
     })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-faq.scss';
#faq-tabs>.row{
  align-items: start;
}
</style>
